import { mobileListApi } from "../../api/mobile/mobileListApi"
import { Mobile } from "../../entities/mobile"

type PayloadShape = Parameters<typeof mobileListApi>[0]

export async function mobileListService(payload: PayloadShape, token?: null | string) {
	const mobile = await mobileListApi(payload, token)
	return mobile as NonNullable<Mobile[]>
}
